import { useRef } from 'react'
import { useButton } from '@react-aria/button'
import { ImageAdd } from 'blaze-ui/icons'
import { AriaButtonProps } from '@react-types/button'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './CampaignMedia.module.scss'

export const NewImageButton = (props: AriaButtonProps) => {
  const ref = useRef(null)
  const { buttonProps } = useButton(props, ref)
  return (
    <button className={Styles.newImageButton} {...buttonProps} ref={ref}>
      <ImageAdd size={24} />{' '}
      <Text variant="smallList" color="inherit">
        Add Media
      </Text>
    </button>
  )
}
